<template>
  <Teleport to="body">
    <focus-trap :active="isVisible">
      <Transition name="side-panel-slide">
        <div
          v-if="isVisible"
          class="side-panel"
          v-bind="$attrs"
          role="dialog"
        >
          <button
            class="side-panel__close"
            @click="close()"
            :aria-label="$t('global.close')"
          />
          <div class="side-panel__container">
            <slot />
          </div>
        </div>
      </Transition>
    </focus-trap>
  </Teleport>
</template>

<script setup lang="ts">
  import pigeon from '../../utilities/js/pigeon/pigeon';
  import {onMounted, watch} from 'vue';
  import {FocusTrap} from 'focus-trap-vue';

  defineOptions({
    inheritAttrs: false
  });

  const props = defineProps<{
    isVisible: boolean
  }>();

  const emits = defineEmits(['closeSidePanel']);

  const close = () => {
    emits('closeSidePanel');
  }

  onMounted(() => {
    pigeon.subscribe('pageoverlay:click', () => {
      if (props.isVisible) {
        close();
      }
    });

    window.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        close();
      }
    });

    if (props.isVisible) {
      handlePageOverlay(true);
    }
  });

  watch(() => props.isVisible, () => {
    handlePageOverlay(props.isVisible);
    handleFocus(props.isVisible);
  });

  function handlePageOverlay(sidePanelActive: boolean) {
    if (sidePanelActive) {
      pigeon.publish('pageoverlay:show');
    } else {
      pigeon.publish('pageoverlay:hide');
    }
  }

  let lastFocusedElm: HTMLElement = null;
  function handleFocus(sidePanelActive: boolean) {
    if (sidePanelActive) {
      lastFocusedElm = document.activeElement as HTMLElement;
    }
    else {
      if (lastFocusedElm) {
        lastFocusedElm.focus();
      }
    }
  }
</script>
